import { PartnerGroupConfig } from './partner-group.types';

export const PARTNER_GROUP_CONFIG: PartnerGroupConfig = {
  title: 'brandFn.menu.partnerGroup',
  viewType: 'table',
  searchFields: [
    {
      name: 'id',
      type: 'number',
      label: 'REPO.TABLE.partnerGroup.id',
      placeholder: 'ID',
    },
    {
      name: 'code',
      type: 'text',
      label: 'REPO.TABLE.partnerGroup.code',
      placeholder: 'partnerGroup.field.code',
    },
    {
      name: 'name',
      type: 'text',
      label: 'REPO.TABLE.partnerGroup.name',
      placeholder: 'partnerGroup.field.name',
    },
    {
      name: 'activeFlg',
      type: 'select',
      label: 'REPO.TABLE.partnerGroup.activeFlg',
      options: [
        { value: '', label: 'COMMON.LABEL.all' },
        { value: 'true', label: 'common.active' },
        { value: 'false', label: 'common.inactive' },
      ],
    },
  ],
  columns: [
    {
      key: 'id',
      name: 'REPO.TABLE.partnerGroup.id',
      type: 'number',
      width: '80px',
      sortable: true,
    },
    {
      key: 'code',
      name: 'REPO.TABLE.partnerGroup.code',
      type: 'text',
      width: '160px',
    },
    {
      key: 'name',
      name: 'REPO.TABLE.partnerGroup.name',
      type: 'text',
      sortable: true,
    },
    {
      key: 'description',
      name: 'REPO.TABLE.partnerGroup.description',
      type: 'text',
    },
    {
      key: 'sortOrder',
      name: 'REPO.TABLE.partnerGroup.sortOrder',
      type: 'number',
      width: '80px',
      sortable: true,
    },
    {
      key: 'activeFlg',
      name: 'REPO.TABLE.partnerGroup.activeFlg',
      type: 'template',
      width: '100px',
    },
    {
      key: 'actions',
      name: 'COMMON.LABEL.actions',
      type: 'actions',
      width: '120px',
      actions: [
        {
          type: 'edit',
          icon: 'bi-pencil',
          label: 'BUTTON.Edit',
          class: 'btn-sm btn-outline-primary',
        },
        {
          type: 'delete',
          icon: 'bi-trash',
          label: 'BUTTON.Delete',
          class: 'btn-sm btn-outline-danger',
        },
      ],
    },
  ],
  defaultSort: 'sortOrder,asc',
  defaultPageSize: 10,
  routePath: '',
};
